// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.M4F9has9d3o9ya {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  min-height: 0;
}
.M4F9has9d3o9ya p {
  padding: var(--ds-space-200, 16px);
}
.M4F9has9d3o9ya section {
  padding-bottom: var(--ds-space-200, 16px);
  overflow-y: auto;
  scrollbar-width: none;
}
.M4F9has9d3o9ya .zYlsj6E1s_Gp2T {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 32px;
  margin-top: auto;
  margin-bottom: var(--ds-space-300, 24px);
  padding: var(--ds-space-100, 8px);
  border-radius: var(--ds-border-radius-200, 8px);
  background: var(--ds-background-accent-gray-subtlest, #f1f2f4);
}
.M4F9has9d3o9ya.W_lkRTIvYD50Xt .zYlsj6E1s_Gp2T {
  margin: var(--ds-space-0, 0) var(--ds-space-100, 8px) var(--ds-space-100, 8px);
}
.PYWheSzNHnu0gZ {
  display: flex;
  column-gap: var(--ds-space-050, 4px);
}
.PYWheSzNHnu0gZ .X2QycEk8ZvTsvR {
  display: none;
}
.oa0P2v2TMHmAXn {
  margin-right: var(--ds-space-100, 8px);
}
.PteVabTgY_Cm4G {
  margin: var(--ds-space-050, 4px);
}
`, ""]);
// Exports
export var selectedWorkspace = `M4F9has9d3o9ya`;
export var footer = `zYlsj6E1s_Gp2T`;
export var panel = `W_lkRTIvYD50Xt`;
export var buttons = `PYWheSzNHnu0gZ`;
export var hideWhenDocked = `X2QycEk8ZvTsvR`;
export var icon = `oa0P2v2TMHmAXn`;
export var offeringLozenge = `PteVabTgY_Cm4G`;
export default ___CSS_LOADER_EXPORT___;
